export const WORD_RUN_TIMEOUT_MS = 5000;
export const WORD_FILE_TIMEOUT_MS = 8000;
export const SFDT_CONVERT_TIMEOUT_MS = 8000;
export const GATHER_TIMEOUT_MS = 20000;
export const TEXT_UPLOAD_TIMEOUT_MS = 15000;

/**
 * Reject if `promise` has not settled. The original work keeps running;
 * callers must treat a timeout as a hard stop and use a fallback.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, message: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error(message));
    }, ms);
    promise.then(
      (value) => {
        clearTimeout(timeoutId);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timeoutId);
        reject(error);
      }
    );
  });
}
